import { Component, ViewChild } from '@angular/core';
import { ProjectService } from '../../services/project.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { switchMap, forkJoin, takeUntil, Subject } from 'rxjs';
import { Goal } from '../../interfaces/models/goal.model';
import { DirectionService } from '../../services/direction.service';
import { GoalService } from '../../services/goal.service';
import { ConfirmPopup, ConfirmPopupModule } from 'primeng/confirmpopup';
import { TagModule } from 'primeng/tag';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { SharedProjectComponent } from '../../shared/components/shared-project/shared-project.component';
@Component({
  selector: 'app-goals-projects',
  standalone: true,
  imports: [ConfirmPopupModule, RouterModule, ButtonModule, TranslateModule, TagModule, CommonModule, SharedProjectComponent],
  templateUrl: './goals-projects.component.html',
  styleUrl: './goals-projects.component.scss',
  providers: [ConfirmationService,],
})
export class GoalsProjectsComponent {
  navigateToProject(projectId: number) {
    this.router.navigate(['/strategies', this.strategyId, 'projects', projectId])
  }
  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  private unsubscribe$ = new Subject<void>();
  projects = [] as any[]
  dir!: 'rtl' | 'ltr';
  strategyId = 0
  goalId = 0
  hoverProjectId = 0
  goal = {} as Goal;
  constructor(
    private confirmationService: ConfirmationService,
    private projectService: ProjectService,
    private goalsService: GoalService,
    private toastr: ToastrService,
    private directionService: DirectionService,
    private route: ActivatedRoute,
    private router: Router
  ) {


  }
  ngOnInit(): void {
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })

    this.route.data.pipe(takeUntil(this.unsubscribe$))
      .subscribe(({ viewBag }) => {
        this.projects = viewBag.projects['data']['projects'];
        this.goal = viewBag.goal['data']['goal'];
        console.log(" viewBag.strategy", viewBag.strategy);
        this.strategyId = viewBag.strategy['data'].strategy.id;
      })
  }
  confirmProjectDelete(event: Event, projectId: number) {
    event.stopPropagation();
    const target = event.target as HTMLElement;
    this.confirmationService.confirm({
      target: target,
      message: this.dir == 'rtl' ? 'هل تريد تأكيد المسح؟' : 'Do you want to confirm the deletion?',
      accept: () => {
        this.projectService.deleteProject(0, projectId).subscribe(() => {
          this.projects = this.projects.filter(x => x.id != projectId);
          this.toastr.success(this.dir == 'rtl' ? 'تم المسح ' : 'The project has been deleted successfully.', this.dir == 'rtl' ? 'عملية ناجحة' : 'Success');
        })
      },
      reject: () => {
        this.toastr.info(this.dir == 'rtl' ? "تم الالغاء" : "The deletion has been canceled.", this.dir == 'rtl' ? 'الغاء' : 'Canceled');
      }
    });
  }
  accept() {
    this.confirmPopup.accept();
  }
  reject() {
    this.confirmPopup.reject();
  }

  onMouseEnter(projectId: number) {
    this.hoverProjectId = projectId;
  }
  onMouseLeave() {
    this.hoverProjectId = 0;
  }
  goBack() {
    window.history.back();
  }
}
